var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewgroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 13.999 13.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6a92c5",
    d: "M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0ZM7,13.124A6.125,6.125,0,1,1,13.124,7,6.125,6.125,0,0,1,7,13.124ZM9.624,6.562H7.437V4.375a.437.437,0,1,0-.875,0V6.562H4.375a.437.437,0,1,0,0,.875H6.562V9.624a.437.437,0,1,0,.875,0V7.437H9.624a.437.437,0,0,0,0-.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewgroup);
export default __webpack_public_path__ + "static/media/newgroup.58a700d2.svg";
export { ForwardRef as ReactComponent };